<div class="filter-wrapper-cont"
  [class.fadeOut]="fadeOut"
  (click)="close()">
</div>
<div class="magic-filters-container {{animation}} animated {{heightClass}}">

  <div class="magicFilters__head">
    <app-ds-header
      [widgetConfig]="headerWidgets$ | async"
      [isTransparent]="true"
      (clickAction)="widgetAction($event)">
    </app-ds-header>
  </div>
  
  <div class="magicFilters__body" [class.magicFilters__body--individual]="individualFilter">
    <ng-content select="[body]"></ng-content>
  </div>

  <div *ngIf="showApplyButton" class="select-filters-on-magic-cont {{heightClass}}">
    <app-fixed-surface
      [boxShadow]="boxShadow"
      [surface]="surface">
      <app-ds-button
        [labels]="{ ButtonLabel: 'SELECT' | transloco }"
        (clickEvent)="close()">
      </app-ds-button>
    </app-fixed-surface>
  </div>

  <ng-template #cleanLabel>
    <span *ngIf="hasFilterSelected" class="clean-label" (click)="clear.emit()">{{ 'CLEAN' | transloco }}</span>
  </ng-template>

</div>